export default __webpack_public_path__ + "static/media/qr-code-2.c6220fee.svg";